const regExp = {
  /*
    * 密码正则表达式
    * 长度： 6~20位
    * 不可：纯数字、纯字母、纯字符
    * 不能包含：空格、空白字符、换行符、中文
    * 其他：数字、字母、字符必须包含至少2种组合
    */
  password: /^(?![0-9]+$)(?![a-zA-Z]+$)(?!([^\w\s]|_)+$)[^\u4e00-\u9fa5\s]{6,20}$/
}

export default regExp
